import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';

const PageHeroEditor = ({
  title,
  setTitle,
  highlight,
  setHighlight,
  description,
  setDescription,
  onSave,
  saving,
  helperText,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Hero Section</CardTitle>
        <CardDescription>Edit the page heading and intro text</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>Title</Label>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} className="mt-1" />
          </div>
          <div>
            <Label>Highlight</Label>
            <Input
              value={highlight}
              onChange={(e) => setHighlight(e.target.value)}
              className="mt-1"
            />
          </div>
        </div>

        <div>
          <Label>Description</Label>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1"
            rows={3}
          />
          {helperText ? <p className="text-xs text-gray-500 mt-2">{helperText}</p> : null}
        </div>

        <Button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700"
        >
          <Save className="mr-2" size={18} />
          Save Hero
        </Button>
      </CardContent>
    </Card>
  );
};

export default PageHeroEditor;
